
export const openChannelPost = (channelData: {
  channel: string;
  postId: string;
  shortcode?: string;
}) => {
  const channel = channelData.channel?.toLowerCase();
  const postId = channelData.postId;
  const shortcode = channelData.shortcode;

  if (!postId) {
    console.warn('No postId provided for channel:', channel);
    return;
  }

  let postUrl = '';

  switch (channel) {
    case 'facebook':
      const [pageId, fbPostId] = postId.split('_');
      if (pageId && fbPostId) {
        postUrl = `https://www.facebook.com/${pageId}/posts/${fbPostId}`;
      }
      break;

    case 'instagram':
      const instagramId = shortcode || postId;
      postUrl = `https://www.instagram.com/p/${instagramId}`;
      break;

    case 'tiktok':
      // TikTok format varies, but typically uses video ID
      postUrl = `https://www.tiktok.com/@username/video/${postId}`;
      break;

    case 'email':
      // Email doesn't have a post URL
      console.info('Email channel does not have a post URL');
      return;

    default:
      console.warn('Unsupported platform:', channel);
      return;
  }

  if (postUrl) {
    window.open(postUrl, '_blank', 'noopener,noreferrer');
  }
};
